export const currentSsoUrl =
  process.env.NODE_ENV === 'production'
    ? process.env.VUE_APP_REALEASE === 'test'
      ? 'http://sso.mini.me'
      : 'https://sso.mini1.cn'
    : 'http://sso.mini.me';

export const ssoLoing = () => {
  location.href = currentSsoUrl + `/#/` + `?url=${location.href}`;
};

export const locationHref =
  process.env.NODE_ENV === 'production'
    ? process.env.VUE_APP_REALEASE === 'test'
      ? 'http://activities-test.mini.me/fe/gaoxiaosaiManage'
      : 'https://sso.mini1.cn'
    : 'http://localhost:8080';
